import { Reveal, SectionHead } from "./Reveal";

const SHOTS = [
  {
    base: "/images/fedari-inspector-wall",
    fallback: "/images/fedari-inspector-wall.jpg",
    alt: "Illustrative inspection scene: wall finish check with flashlight and tablet",
    caption: "On-site snagging with photo documentation",
  },
  {
    base: "/images/fedari-inspector-pipes",
    fallback: "/images/fedari-inspector-pipes.jpg",
    alt: "Illustrative inspection scene: accessible plumbing and valves check",
    caption: "Checking accessible plumbing and building services",
  },
];

export default function InspectorGallery() {
  return (
    <section className="py-24 lg:py-28 bg-white border-t border-line" data-testid="home-inspector-gallery">
      <div className="wrap">
        <SectionHead
          eyebrow="What an inspection looks like"
          title="Meticulous, documented checks."
          sub="Every Fedari inspection is a careful, room-by-room examination of finishes, fixtures and accessible building services — captured in a clear photo report delivered within the confirmed timeframe."
        />
        <div className="grid md:grid-cols-2 gap-4 lg:gap-5">
          <Reveal className="md:col-span-2">
            <figure className="group relative overflow-hidden rounded-[16px] border border-line bg-soft">
              <picture>
                <source
                  type="image/avif"
                  srcSet="/images/fedari-team-fleet-800.avif 800w, /images/fedari-team-fleet-1280.avif 1280w, /images/fedari-team-fleet-1983.avif 1983w"
                  sizes="(max-width: 768px) 100vw, 1120px"
                />
                <source
                  type="image/webp"
                  srcSet="/images/fedari-team-fleet-800.webp 800w, /images/fedari-team-fleet-1280.webp 1280w, /images/fedari-team-fleet-1983.webp 1983w"
                  sizes="(max-width: 768px) 100vw, 1120px"
                />
                <img
                  src="/images/fedari-team-fleet-1280.webp"
                  alt="Fedari inspection team in branded uniform with Fedari vans on site in Dubai"
                  loading="lazy"
                  width="1983"
                  height="793"
                  className="w-full h-[240px] sm:h-[320px] lg:h-[420px] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                  data-testid="inspector-photo-team"
                />
              </picture>
              <figcaption className="absolute inset-x-0 bottom-0 px-5 py-3.5 text-[0.8rem] font-medium text-white bg-gradient-to-t from-navy/80 to-transparent">
                The Fedari team, ready for your inspection
              </figcaption>
            </figure>
          </Reveal>
          {SHOTS.map((s, i) => (
            <Reveal key={s.base} delay={i * 0.08}>
              <figure className="group relative overflow-hidden rounded-[16px] border border-line bg-soft">
                <picture>
                  <source
                    type="image/avif"
                    srcSet={`${s.base}-800.avif 800w, ${s.base}-1280.avif 1280w, ${s.base}-1728.avif 1728w`}
                    sizes="(max-width: 768px) 100vw, 50vw"
                  />
                  <source
                    type="image/webp"
                    srcSet={`${s.base}-800.webp 800w, ${s.base}-1280.webp 1280w, ${s.base}-1728.webp 1728w`}
                    sizes="(max-width: 768px) 100vw, 50vw"
                  />
                  <img
                    src={s.fallback}
                    alt={s.alt}
                    loading="lazy"
                    width="1728"
                    height="1152"
                    className="w-full h-[260px] sm:h-[340px] lg:h-[420px] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                    data-testid={`inspector-photo-${i}`}
                  />
                </picture>
                <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-navy/75 to-transparent text-white text-sm font-medium px-5 py-4">
                  {s.caption}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
